import { render, staticRenderFns } from "./AlbumCreate.vue?vue&type=template&id=3af01b65&scoped=true"
import script from "./AlbumCreate.vue?vue&type=script&lang=js"
export * from "./AlbumCreate.vue?vue&type=script&lang=js"
import style0 from "./AlbumCreate.vue?vue&type=style&index=0&id=3af01b65&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af01b65",
  null
  
)

export default component.exports